var render = function render(){var _vm=this,_c=_vm._self._c;return _c('v-container',{attrs:{"fluid":""}},[_c('div',{staticClass:"text-h6 text-sm-h5 font-weight-bold text-center text-sm-left mb-6"},[_vm._v(" Marcas ")]),_c('TabNavigation',{attrs:{"tabs":_vm.tabs,"type":"path","keyValue":"/brands"}}),_c('v-divider',{staticClass:"surface mb-4"}),_c('router-view')],1)
}
var staticRenderFns = []

export { render, staticRenderFns }